import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';

function TextField(props) {
    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    return(
        <InputGroup className="mb-3">
            {props.title != undefined ?
                <InputGroup.Prepend>
                    <InputGroup.Text>{props.title}</InputGroup.Text>
                </InputGroup.Prepend>
            : null}
            <Form.Control autoComplete="disabled" onKeyDown={ props.onKeyDown } type="text" disabled={props.disabled} onChange={(evt) => handleChange(evt.target.value)} value={props.value != undefined && props.value != "" ? props.value : (props.defaultValue != undefined ? props.defaultValue : "")} placeholder={ props.placeholder }/>
        </InputGroup>
    );
}

export default TextField;